<a (click)="openDialogLogSolicitud()">Ver {{logs.length}} Comentarios</a>